
import { FileText } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

interface ArticleSummarySectionProps {
  description_en: string;
  setDescriptionEn: (value: string) => void;
  description_ko: string;
  setDescriptionKo: (value: string) => void;
  isEnglish: boolean;
}

// Recommended summary length so the card's 3-line clamp shows the full text.
// Korean is denser (fewer characters per line), so it gets a lower target.
const SUMMARY_TARGET = { en: 140, ko: 80 };

const ArticleSummarySection = ({
  description_en,
  setDescriptionEn,
  description_ko,
  setDescriptionKo,
  isEnglish,
}: ArticleSummarySectionProps) => {
  const value = isEnglish ? description_en : description_ko;
  const target = isEnglish ? SUMMARY_TARGET.en : SUMMARY_TARGET.ko;
  const count = value.length;
  const isOver = count > target;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="flex items-center gap-2">
          <FileText className="w-4 h-4 text-gray-500" />
          {isEnglish ? "Article Summary" : "기사 요약"}
        </Label>
        <span
          className={cn(
            'text-xs tabular-nums',
            isOver ? 'font-medium text-amber-600' : 'text-gray-400'
          )}
        >
          {count} / ~{target}
        </span>
      </div>
      <Textarea
        placeholder={isEnglish ? "Brief summary of the article..." : "기사에 대한 간단한 요약..."}
        value={isEnglish ? description_en : description_ko}
        onChange={(e) => isEnglish ? setDescriptionEn(e.target.value) : setDescriptionKo(e.target.value)}
        className="min-h-[100px] border-gray-200 focus:border-gray-300 focus:ring-gray-200"
      />
      {isOver && (
        <p className="text-xs text-amber-600">
          Over the recommended length — the card clamps to 3 lines, so the end may be hidden. Check the live preview.
        </p>
      )}
    </div>
  );
};

export default ArticleSummarySection;
